$(document).ready(function () {
var checkDropdown = setInterval(function () {
  var $button = $(".dropdown-btn");
  var $dropdown = $("ul.localization__item.dropdown-ul");

  if ($dropdown.length && $button.length) {
    // setTimeout(() => {
    //   clearInterval(checkDropdown); 
    // }, 2000);
    var $options = $(".dropdown-li a");

    $button.on("click", function (e) {
      e.stopPropagation();
      $dropdown.toggleClass("active");
    });

    $options.on("click", function () {
      $dropdown.removeClass("active");
    });

    $(document).on("click.dropdown", function (e) {
      if (!$dropdown.is(e.target) && 
          $dropdown.has(e.target).length === 0 &&
          !$button.is(e.target) &&
          $button.has(e.target).length === 0) {
        $dropdown.removeClass("active");
      }
    });

    // console.log("Dropdown JS initialized ✅");
  }
}, 1000);
});